package one.healthium.pilates

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import ifaandroid.apps.pilates.composeapp.generated.resources.Res
import ifaandroid.apps.pilates.composeapp.generated.resources.img_water_footer
import ifaandroid.apps.pilates.composeapp.generated.resources.paytoneone_regular
import one.healthium.ui.compose.components.AppTopBarStyle
import one.healthium.ui.compose.theme.AppTextStyle
import one.healthium.ui.compose.theme.AppThemeBase
import one.healthium.ui.compose.theme.Colors
import one.healthium.ui.compose.theme.Shapes
import one.healthium.ui.compose.theme.gray_19
import one.healthium.ui.compose.theme.orange_3
import one.healthium.ui.compose.theme.styles.ChartStyle
import one.healthium.ui.compose.theme.styles.ContentCardStyle
import one.healthium.ui.compose.theme.styles.DailyTaskItemStyle
import one.healthium.ui.compose.theme.styles.DailyTaskStyle
import one.healthium.ui.compose.theme.styles.LogControlStyle
import one.healthium.ui.compose.theme.styles.LogWaterControlStyle
import one.healthium.ui.compose.theme.styles.LogWeightControlStyle
import one.healthium.ui.compose.theme.styles.ProfileStyle
import one.healthium.ui.compose.theme.styles.TutorialStyle
import one.healthium.ui.compose.theme.white
import one.healthium.ui.compose.theme.yellow
import org.jetbrains.compose.resources.Font

@Composable
internal fun pilates() = AppThemeBase(
    colors = Colors.pilates,
    shapes = Shapes.pilates,
    textStyles = AppTextStyle(
        fontFamily = null,
        fontFamilySecondary = null,
    ),
    dailyTasksStyle = DailyTaskStyle(
        itemStyle = DailyTaskItemStyle.V2(),
    ),
    appTopBarStyle = AppTopBarStyle(
        style = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 17.sp,
            letterSpacing = -(0.41).sp,
        )
    ),
    contentCardStyle = ContentCardStyle(
        titleStyle = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 20.sp,
        ),
    ),
    logWaterControlStyle = LogWaterControlStyle(
        footerImage = Res.drawable.img_water_footer,
        titleStyle = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 30.sp,
            letterSpacing = -(0.6).sp,
        ),
    ),
    logWeightControlStyle = LogWeightControlStyle(
        titleStyle = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 30.sp,
            letterSpacing = -(0.6).sp,
        ),
    ),
    logControlStyle = LogControlStyle(
        titleStyle = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 30.sp,
            letterSpacing = -(0.6).sp,
        ),
    ),
    profileStyle = ProfileStyle(
        weightProgressBarStyle = ChartStyle(
            barColor = white,
            highlightedBarColor = yellow,
        ),
        weightProgressChartStyle = ChartStyle(
            barColor = gray_19,
            highlightedBarColor = yellow,
        ),
        caloriesChartStyle = ChartStyle(
            barColor = gray_19,
            highlightedBarColor = yellow,
        ),
        avatarContainerColor = orange_3,
    ),
    tutorialStyle = TutorialStyle(
        titleStyle = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 30.sp,
            letterSpacing = -(0.6).sp,
        ),
        messageStyle = TextStyle(
            fontSize = 18.sp,
            lineHeight = 24.sp,
        ),
    ),
)

private val PaytoneOneFontFamily
    @Composable get() = FontFamily(
        Font(Res.font.paytoneone_regular, FontWeight.Normal),
    )
